import React, { useRef } from 'react';
import type { AnywhereListing } from '../../types';
import { anywhereTypeLabel } from '../../helpers';
import { Button } from 'components/ui/button';
import { showSnackbar } from 'components/ui/snackbar/helper';

import { useDrag } from 'react-dnd';

type AnywhereListingRowProps = {
  listing: AnywhereListing,
  onHide?: () => void;
}

function AnywhereListingRow({ listing, onHide } : AnywhereListingRowProps) {
  const handleCopyGuid = (guid: string) => {
    navigator.clipboard.writeText(guid);
    showSnackbar({ text: 'GUID copied to clipboard!', variant: 'success' });
  };

  const dragRef = useRef(null);

  // make listing guid draggable
  const [{ isDragging }, drag] = useDrag({
    collect: monitor => ({ isDragging: monitor.isDragging() }),
    item: listing,
    type: 'listing-guid'
  });

  drag(dragRef);


  const { propertyLocation: { addressLine1, city, stateProvinceName, postalCode } } = listing;
  return (
    <tr key={listing.listingId}>
      <td>
        <Button label="Hide" variant="destructive" onClick={onHide} />
      </td>
      <td>
        <div>
          {anywhereTypeLabel(listing.typeDescription)}
        </div>
        <div className="text-muted small">
          {listing.listingId}
        </div>
        <div>
          {listing.statusDescription}
        </div>
      </td>
      <td>{addressLine1}, {city}, {stateProvinceName} {postalCode}</td>
      <td
        className="clickable"
        ref={dragRef}
        style={{ cursor: 'grab', opacity: isDragging ? 0 : 1 }}
        onClick={() => handleCopyGuid(listing.listingGuid)}
      >
        <div>
          <div>
            {listing.listingGuid}
          </div>
          <div className="text-muted small">
            Click to copy GUID
          </div>
        </div>
      </td>
    </tr>
  );
}

export default AnywhereListingRow;
